<template>
  <div class="oldest-container" ref="container">
    <div>
      <div class="content" :style="conHeight">
        <div class="contents">
          <el-row style="height:100%" :gutter="20">
            <el-col :span="12" style="height:100%">
              <div class="left" >
                <div class="left-top" >
                    <div class="char" >
                          高龄老人分布
                    </div>
                </div>
                <div id="column" ></div>
              </div>
            </el-col>
            <el-col :span="12" style="height:100%">
              <div class="right" >
                <div class="right-top" >
                  <div class="char" >
                    新增老人
                  </div>
                </div>
                <div class="right-bottom" >
                  <template>
                    <el-table
                      :data="tableData"
                      stripe height="100%">
                      <el-table-column
                        prop="name"
                        label="姓名"
                        width="180">
                      </el-table-column>
                      <el-table-column
                        prop="gender"
                        :formatter="getGender"
                        label="性别"
                        width="180">
                      </el-table-column>
                      <el-table-column
                        prop="birthday"
                        :formatter="getAge"
                        label="年龄">
                      </el-table-column>
                      <el-table-column
                        prop="address"
                        label="户籍">
                      </el-table-column>
                      <el-table-column
                        prop="applyType"
                        :formatter="getApplyType"
                        label="申请类型">
                      </el-table-column>
                    </el-table>
                  </template>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="height:100%">
              <div class="right" >
                <div class="right-top" >
                    <div class="char" >
                          高龄津贴打卡记录
                    </div>
                </div>
                <div class="right-bottom" >
                  <template>
                    <el-table
                      :data="tableData2"
                      stripe height="100%">
                      <el-table-column
                        prop="name"
                        label="姓名"
                        width="180">
                      </el-table-column>
                      <el-table-column
                        prop="gender"
                        :formatter="getGender"
                        label="性别"
                        width="180">
                      </el-table-column>
                      <el-table-column
                        prop="age"
                        label="年龄">
                      </el-table-column>
                      <el-table-column
                        prop="address"
                        show-overflow-tooltip
                        label="打卡地址">
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        prop="remark"
                        label="打卡备注">
                      </el-table-column>
                    </el-table>
                  </template>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="height:100%">
              <div class="right" >
                <div class="right-top" >
                    <div class="char" >
                          核减人数
                    </div>
                </div>
                <div class="right-bottom" >
                  <template>
                    <el-table
                      :data="tableData3"
                      stripe height="100%">
                      <el-table-column
                        prop="name"
                        label="姓名"
                        width="180">
                      </el-table-column>
                      <el-table-column
                        prop="gender"
                        :formatter="getGender"
                        label="性别"
                        width="180">
                      </el-table-column>
                      <el-table-column
                        prop="birthday"
                        :formatter="getAge"
                        label="年龄">
                      </el-table-column>
                      <el-table-column
                        prop="address"
                        label="户籍">
                      </el-table-column>
                      <el-table-column
                        prop="applyType"
                        :formatter="getApplyType"
                        label="申请类型">
                      </el-table-column>
                    </el-table>
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div>

    </div>
  </div>
</template>

<script>
// import countTo from 'vue-count-to'
// import {timefilters} from "@/common/times";
import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getToken} from "@/utils/auth"
export default {
  name: "Home",
  data() {
    return {
      routerValue: [
        [8, '居家养老', '/HomeCare'],
        [8, '机构养老', '/Institution'],
        [8, '社区养老', '/CommunityRetirement'],
        [6, '志愿者', '/Volunteer'],
        [6, '高龄津贴', '/OldAgeAllo'],
        [6, '服务对象', '/ServiceObject'],
        [6, '智能设备', '/IntelligentDevice']
      ],

      conHeight: {
        height: ''
      },
      column:'',
      tableData: [],
      tableData2: [],
      tableData3: [],
      barData:{
        woman:'',
        man:''
      }

    }
  },
  mounted() {
    this.$nextTick(() => { // 页面渲染完成后的回调
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    })
    this.init()
    var that = this
    window.addEventListener("resize", () => {
      that.column.resize();

    });
  },
  components: {},
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    },
  },
  // created(){
  //    this.init()
  // },
  methods: {
    init() {
      this.$store.commit('update', ['title', '高龄津贴']);
      this.getAxios("Views/OldestByAge").then(resolve=>{
          this.barData.woman=[resolve.ageOneWoman,resolve.ageTwoWoman,resolve.ageThreeWoman]
          this.barData.man=[resolve.ageOneMan,resolve.ageTwoMan,resolve.ageThreeMan]
          this.getColumn();
      })
      this.$axios({
          method: 'post',
          url: this.$visualizationUrl+"Views/GetOldestAddList",
          data: {
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            visualAccountHomeGovernmentCodeList: JSON.parse(getToken()).visualAccountHomeGovernmentCodeList,
          }
      }).then( (response)=> {
          if(response.data.error == 0){
              this.tableData=response.data.data.list
          }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
          }
      })
      this.$axios({
        method: 'post',
        url: this.$visualizationUrl+"/Views/OldestDaKaJiLu",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          visualAccountHomeGovernmentCodeList: JSON.parse(getToken()).visualAccountHomeGovernmentCodeList,
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          console.log("response.data.data: ",response.data.data);
          this.tableData2 = response.data.data.oldestClockinDTO2List;
          this.tableData3 = response.data.data.oldestList;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })
    },
    getGender(row,index,column){
      return column==0?'女':'男'
    },
    getApplyType(row,index,column){
      return column==0?'80-90周岁':'100周岁以上'
    },
    getAge(row,index,column){
      return parseInt(timefilters(new Date()).slice(0,4))-parseInt(timefilters(new Date(column)).slice(0,4))
    },
    getAxios(url){
        return new Promise((resolve, reject) => {
            this.$axios({
                method: 'post',
                url: this.$visualizationUrl+url,
                data: {
                  timeStr:timeStr,
                  sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  visualAccountHomeGovernmentCodeList: JSON.parse(getToken()).visualAccountHomeGovernmentCodeList,
                }
            }).then( (response)=> {
                if(response.data.error == 0){
                    resolve(response.data.data);
                }else if(response.data.error == 1){
                    this.$message({type: 'info', message: response.data.message});
                }
            }).catch(function (error) {
                reject(error.data)
            });
        });
    },
    getColumn(){
      this.column = this.$echarts.init(document.getElementById('column'))
      var option={
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ['男', '女'],
          align: 'right',
          top:25,
          textStyle: {
            color: "#fff"
          }
        },
        grid: [{
          // show: true,
          left: '10%',
          right: '12%',
          bottom: 50,
          top: '20%',
        }
        ],
        xAxis: [
          {type: 'category',
            data: ['80岁至89岁','90岁至99岁','100岁以上'],
            splitNumber: 6,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "rgba(35,242,255,1)"
              }
            },
            axisLabel: {
              interval: 0,
              color:'#fff'
            }
          }],
        yAxis: [{
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            lineStyle: {
              color: 'rgba(18, 114, 189, 1)',
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(35,242,255,1)"
            }
          },
          axisLabel:{
            color:'#fff'
          }
        }],
        series: [

          {
            name:"男",
            type: 'bar',
            barWidth: "10%",
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: "#EE7E1B"
                },
                  {
                    offset: 1,
                    color: '#EEC91B'
                  }
                ]),
              }
            },
            data: this.barData.man},
          {
            name:"女",
            type: 'bar',
            barWidth: "10%",
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: "#0065D7"
                },
                  {
                    offset: 1,
                    color: '#00FCFF'
                  }
                ]),
              }
            },
            data: this.barData.woman
          }

        ]
      }
      this.column.setOption(option)
    },


  }
}


</script>

<style lang="scss" scoped>
.oldest-container {
  width: 100%;
  height: 100vh;
  margin-top: -75px;
  background-image: url(./img/background.jpg);
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center top;
  min-width: 1320px;
  min-height: 736px;

  .content {
    height: 100%;
    margin: 0;
    padding: 0;
    // margin-top: 80px;
    padding: 0 2.6vw;
    padding-top: 90px;
  }

  .contents {
    min-width: 1220px;
    min-height: 90vh;


    #column{
      //border: 1px solid yellow;
      height: 340px;
      width: 100%;
    }

    .left{
      border: 1px solid rgba(30,135,255,1);
      background: rgba(1, 3, 66, 0.2);
      height: 41vh;
      margin: 1vh 0;
      .left-top{
        background-size: 100% 100%;
        background-image: url(./img/top2.png);
        background-repeat: no-repeat;
        height: 50px;
        width: 50%;
        margin: 0 auto;
        line-height: 43px;
        .char{
          font-size:28px;
          font-family:Microsoft YaHei;
          font-weight:bold;
          color:rgba(20,241,255,1);
          height: 100%;
          text-align: center;
        }
      }
    }
    /deep/ .el-table {
          background-color:transparent;
        }
        .el-table::before {
          height: 0px;
        }


        /deep/ .el-table th {
          background-color:transparent;
        }
        /deep/ .el-table__row td{
          border: none;
        }
        /deep/ .el-table__header tr {
          //background-image: linear-gradient(to right,rgba(1, 125, 252, 1),rgba(5, 140, 255, 0.01));
          background-color: rgba(14, 115, 232, 1);
        }
        /deep/ .el-table__body .el-table__row{
          background-color: transparent;
        }
        ///deep/ .el-table__body .el-table__row--striped{
        //  //background-color: rgba(2, 52, 126, 1);
        //  background-color: transparent;
        //}
        /deep/ .el-table__body .el-table__row--striped td{
          background-color:transparent;
        }
        /deep/ .el-table th.is-leaf {
          border: 0;
        }
        /deep/ .el-table__header .cell {
          color: rgba(28, 252, 255, 1);
        }
        /deep/ .el-table td div {
          color: rgba(161, 212, 255, 1);
        }
        /deep/  .el-table__body{
          width: 100% !important;
        }
        /deep/ .el-table__header .gutter{
          display: none !important;
        }
        /deep/ .el-table tbody tr:hover>td {
            background-color:transparent!important
        }
        /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {width: 17px;}
        /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
          border-radius: 10px;
          display: none;
          background: #00FFFF;
        }
        /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
          border-radius: 0;
          background: transparent;
        }



    .right{
      border: 1px solid rgba(30,135,255,1);
      height: 41vh;
      background: rgba(1, 3, 66, 0.2);
      margin: 1vh 0;
      .right-top{
        background-size: 100% 100%;
        background-image: url(./img/top2.png);
        background-repeat: no-repeat;
        height: 50px;
        width: 50%;
        margin: 0 auto;
        line-height: 43px;
        .char{
          font-size:28px;
          font-family:Microsoft YaHei;
          font-weight:bold;
          color:rgba(20,241,255,1);
          height: 100%;
          text-align: center;
        }
      }

      .right-bottom{
        width: 94%;
        margin: 10px auto;
        height: 310px;
        //border: 1px solid red;


      }


    }

  }
}

</style>
